/* ------------------------------------------------------------------
   Strapion — comportamiento propio sobre el tema Horizon
   Archivo aparte: no lo sobrescriben las actualizaciones del tema.
   ------------------------------------------------------------------ */

/* Cerrar el zoom de producto al pulsar fuera de la ventana.
   Un <dialog> modal no cierra solo al clicar el backdrop: el navegador
   dirige ese clic al propio <dialog>, así que basta con comprobar que el
   destino es el diálogo y no un hijo suyo. */
(function () {
  'use strict';

  var SELECTOR = 'dialog.dialog-zoomed-gallery__dialog';

  function enlazar(dialog) {
    if (dialog.dataset.strapionBackdropClose) return;
    dialog.dataset.strapionBackdropClose = '1';

    // Guardamos dónde empezó el arrastre: sin esto, arrastrar la foto y
    // soltar fuera cerraría la ventana sin querer.
    var abajoEnBackdrop = false;

    dialog.addEventListener('mousedown', function (e) {
      abajoEnBackdrop = e.target === dialog;
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog && abajoEnBackdrop) dialog.close();
      abajoEnBackdrop = false;
    });
  }

  function escanear() {
    document.querySelectorAll(SELECTOR).forEach(enlazar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', escanear);
  } else {
    escanear();
  }

  // El diálogo puede inyectarse después (cambio de variante, navegación
  // por secciones del editor), así que vigilamos el DOM.
  new MutationObserver(escanear).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

/* Marcar como activo el botón del selector de colección que corresponde
   a la página actual. Los ajustes del tema no permiten condicionales,
   así que se resuelve en cliente comparando la ruta. */
(function () {
  'use strict';

  function marcar() {
    var ruta = location.pathname;
    document.querySelectorAll('a.collection-switch').forEach(function (a) {
      var destino = a.getAttribute('href') || '';
      var activo = destino && ruta.indexOf(destino) === 0;
      if (activo) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', marcar);
  } else {
    marcar();
  }
})();
